<template>
    <div id="goodsDetail">
        <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            @load="onLoad"
        >
            <div class="backBox">
                <van-icon @click="$router.back()" name="arrow-left" />
                <!-- <p></p><van-icon name="share" @click="$toast('分享')" /> -->
            </div>
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                <van-swipe-item v-for="(item,index) in (goodsDetail.productImage ? goodsDetail.productImage.split(',') : [])" :key="index">
                    <img :src="baseUrl.imgUrl + item" class="my-swipe-img" alt="">
                </van-swipe-item>
            </van-swipe>
            <van-card>
                <template #origin-price>
                    <div>
                        <div class="van-card__origin-price" style="text-decoration: line-through;" v-if="goodsDetail.productPreferentialPrice!=null">¥ {{goodsDetail.productPrice}}</div>
                        <span v-if="goodsDetail.giveCredit!=null" style="margin-left:10px;font-size:0.3rem;">原价购买可返积分{{goodsDetail.giveCredit}}</span>
                    </div>
                </template>
                <template #price>
                    <div><span class="van-card__price-currency">¥</span><span class="van-card__price-integer">{{goodsDetail.productPreferentialPrice==null?goodsDetail.productPrice:goodsDetail.productPreferentialPrice}}</span></div>
                </template>
                <template #title>
                    <p class="cardTitle">{{ goodsDetail.productName }}</p>
                </template>
                <template #desc>
                    <div class="card-line clearfix">
                        <div class="card-line-item">
                            <span class="sale-type">已售</span>
                            <span class="sale-number">{{ goodsDetail.productSalesNumber || 0 }}</span>
                            <span class="sale-type">剩余</span>
                            <span class="sale-number">{{ goodsDetail.productNum || 0 }}</span>
                        </div>
                        <div class="card-line-item" v-if="goodsDetail.isNight === 1">
                            <span class="sale-time">夜间商品</span>
                        </div>
                    </div>
                    <p class="card-subLine" v-if="goodsDetail.isOpenCredit == 1">¥{{ goodsDetail.creditProductPrice || 0 }}+{{ goodsDetail.needCredit || 0 }}积分</p>
                </template>
                <template #num>
                    <img class="cardNum" src="~img/home/add.png" alt="" @click="handleNum(1)">
                    <span class="cardNumS" v-if="shoppingCartNum>0">{{shoppingCartNum}}</span>
                    <img class="cardNum" src="~img/home/reduce.png" alt="" @click="handleNum(-1)" v-if="shoppingCartNum>0">
                </template>
            </van-card>
            <p class="distributionP" v-if="goodsDetail.businessProperty === 3">
                <span>配送</span>物业配送 可自提
            </p>
            <div class="navBarBottom">
                <div class="navBarBottomL">
                    <van-image :src="baseUrl.imgUrl+goodsDetail.businessLogo" />
                </div>
                <div class="navBarBottomR">
                    <p class="navBarBottomRP_">
                        {{goodsDetail.businessName}}
                    </p>
                    <p class="navBarBottomRP">
                        <van-icon color="#E0665A" name="fire-o" /> 销量{{goodsDetail.totalSales}}
                        <van-icon color="#E0665A" name="fire-o" /> {{goodsDetail.praise}}个用户好评
                    </p>
                </div>
                <van-button class="navBarBottomBtn" round color="#666" size="small" plain @click="$router.push('/bfMerchantsShop?businessNumber='+goodsDetail.productBusinessNumber+'&&businessProperty='+goodsDetail.businessProperty)">进店逛逛</van-button>
            </div>
            <van-tabs swipeable animated sticky v-model="active" title-active-color="#000" title-inactive-color="#999">
                <van-tab title="商品详情">
                    <div class="detail-editor" v-html="goodsDetail.productDetails"></div>
                </van-tab>
                <van-tab title="评价">
                    <div class="evaluationBox">
                        <van-row class="evaluationTietle">
                            <van-col span="6" class="evaluationTotalScore">{{ goodsComment.score || 0 }}</van-col>
                            <van-col span="9" class="evaluationTotalScore_">
                                <p>综合评分</p>
                                <van-rate v-model="evaluationValue" readonly />
                            </van-col>
                            <van-col span="9" class="evaluationTotalNum">
                                <p>评论数</p>
                                <p class="evaluationTotalNum_">{{ goodsComment.pagelist ? goodsComment.pagelist.pagination.total : 0 }}</p>
                            </van-col>
                        </van-row>
                        <div class="evaluationContent" v-for="(item, index) in evaluationList" :key="index">
                            <div class="evaluationContentImg">
                                <img src="~img/common/touxiang.png" alt="">
                            </div>
                            <div class="evaluationContentInfo">
                                <div class="evaluationContentInfoH">
                                    <p>{{ item.orderUserPhone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2") }}<span>{{ item.orderTime }}</span></p>
                                    <van-rate v-model="item.orderEvaluateEvaLevel" readonly />
                                </div>
                                <div class="evaluationContentInfoBody">
                                    <p class="evaluationContentInfoBodyTitle">{{ item.orderEvaluateContent }}</p>
                                    <div class="evaluationContentInfoBodyImg">
                                        <van-row gutter="10">
                                            <van-col span="8" v-for="(it,ind) in (item.orderEvaluationImg ? item.orderEvaluationImg.split(',') : [])" :key="ind">
                                                <img :src="baseUrl.imgUrl + it" alt="" @click="lookImgFn(baseUrl.imgUrl + it,index)">
                                            </van-col>
                                        </van-row>
                                    </div>
                                    <p class="evaluationContentInfoBodyReply" v-if="item.orderEvaluateReplyContent!=''&&item.orderEvaluateReplyContent!=null">
                                        商家回复：{{item.orderEvaluateReplyContent}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
            <van-goods-action>
                <van-goods-action-icon icon="wap-home-o" text="首页" @click="$router.push('/')" />
                <van-goods-action-icon icon="cart-o" :badge="allCartNum || 0" text="购物车" @click="$router.push('/shoppingCart?noNavBar=true')" />
                <!-- <van-goods-action-button type="warning" text="加入购物车" @click="linkCart" /> -->
                <van-goods-action-button :disabled="settleParams.isSettle!=1 || goodsDetail.businessStatus != 1" type="danger" :text="btnText" @click="linkConfirm" />
            </van-goods-action>
        </van-list>
    </div>
</template>

<script>
import Cart from '@/config/shopCart';
import { ImagePreview } from 'vant';
import baseUrl from '@/config/baseUrl';
import { mapState, mapActions } from 'vuex';
export default {
    name: 'GoodsDetail',
    mixins: [Cart],
    data() {
        return {
            baseUrl,
            active:0,
            evaluationValue: 4,
            productId: '',
            loading: false,
            finished: false,
            searchData: {
                orderDetailsProductId: '',
                current: 1,
                pageSize: 10
            },
            shoppingCartNum: 0,
            cart: {},
            settleParams:{
                isSettle:-1,
                discountTopic:''
            }
        };
    },
    computed: {
        ...mapState('goods', {
            goodsDetail: 'goodsDetail',
            goodsComment: 'goodsComment'
        }),
        evaluationList() {
            if(this.goodsComment.pagelist && this.goodsComment.pagelist.list) {
                return this.goodsComment.pagelist.list;
            }
            return [];
        },
        btnText() {
            if(this.settleParams.isSettle === 1) {
                return '立即购买';
            }
            if(this.settleParams.discountTopic) {
                return this.settleParams.discountTopic;
            }
            if(this.goodsDetail.businessStatus === 2) {
                return '商家休业中';
            }
            return '立即购买';
        }
    },
    watch: {
        goodsDetail: {
            handler() {
                this.setCart();
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('goods', {
            getGoodsDetail: 'getGoodsDetailAction',
            getGoodsComment: 'getGoodsCommentAction',
            clearGoodsDetail: 'clearGoodsDetailAction'
        }),
        ...mapActions('confirmOrder', {
            setOrderParams: 'setOrderParamsAction'
        }),
        linkCart() {
            if(this.shoppingCartNum<1) {
                this.$toast('请先选择商品数量');
                return;
            }
            this.$router.push('/shoppingCart?noNavBar=true');
        },
        linkConfirm() {
            if(this.shoppingCartNum<1) {
                this.$toast('请先选择商品数量');
                return;
            }
            this.setOrderParams({
                productIds: this.goodsDetail.productId,
                businessProperty: this.goodsDetail.businessProperty,
                businessNumber: this.goodsDetail.productBusinessNumber
            });
            this.$router.push('/confirmOrder');
        },
        handleNum(type){
            this.updateCart({
                productId: this.goodsDetail.productId,
                productNum: type
            }).then((res) => {
                this.setCart();
                //拉取购物车总数量
                this.getCartNum();
                this.$toast(res.msg);
            }).catch((res) => {
                this.$toast(res.error);
            });
        },
        //当前商品购物车内数量
        setShopCartNum() {
            let { shopCartMap } = this.cart,
                { productBusinessNumber, businessName, productId } = this.goodsDetail;
            if(shopCartMap && productBusinessNumber && businessName && productId) {
                let data = shopCartMap[`${productBusinessNumber}:${businessName}`],
                    row = data ? data.find(item => item.productId === productId) : {};
                this.shoppingCartNum = row?row.productNum : 0;
                if(!this.shoppingCartNum){
                    this.settleParams = {
                        isSettle:-1,
                        discountTopic:''
                    };
                }else{
                    this.settleFn();
                }
            }
        },
        setCart() {
            const { productBusinessNumber, businessProperty } = this.goodsDetail;
            this.getCartList({
                businessNumber: productBusinessNumber,
                businessProperty: businessProperty
            }).then((res) => {
                if(businessProperty === 2) {
                    this.cart = this.bfCart;
                }else if(businessProperty === 3) {
                    this.cart = this.wyCart;
                }else if(businessProperty === 4) {
                    this.cart = this.zbCart;
                }
                this.setShopCartNum();
            });
        },
        onClickButton() {
            this.$toast('点击按钮');
        },
        lookImgFn(imgData,index){
            ImagePreview({
                images: imgData,
                startPosition: index
            });
        },
        onLoad() {
            this.loading = true;
            this.getGoodsComment(this.searchData).then((res) => {
                this.searchData.current++;
                this.loading = false;
                if(res.pagelist.list.length<10) {
                    this.finished = true;
                }
                this.evaluationValue = res.score || 0;
            });
        },
        settleFn(){
            this.settleCart({
                businessProperty: this.goodsDetail.businessProperty,
                businessNumber: this.goodsDetail.productBusinessNumber,
                productIds: this.$route.params.id
            }).then((data) => {
                this.settleParams = data.data;
            }).catch((data) => {
                this.$toast(data.error);
            });
        }
    },
    created() {
        this.productId = this.$route.params.id;
        this.searchData.orderDetailsProductId = this.$route.params.id;
        this.getGoodsDetail({ productId: this.productId }).then((data) => {
            // this.settleFn();
        }).catch((data) => {
            this.$toast(data.error);
            this.$router.back();
        });
        this.onLoad();
        //拉取购物车总数量
        this.getCartNum();
    },
    beforeDestroy() {
        this.clearGoodsDetail();
    }
};
</script>
<style lang="scss">
    #goodsDetail{
        position: relative;
        .backBox{
            position:absolute;
            top: 15px;
            left: 15px;
            z-index: 999;
            width:40px;
            height:31px;
            background:rgba(0,0,0,0.45);
            border-radius:16px;
            text-align: center;
            p{
                margin: 5px 10px 0;
                border-right: 1px solid #8B8B8B;
                height: 20px;
                display: inline-block;
                opacity:0.5;
            }
            .van-icon{
                font-size: 20px;
                line-height: 31px;
                color: #fff;
            }
        }
        .my-swipe {
            .my-swipe-img {
                width: 100%;
            }
            .van-swipe-item {
                height: 325px!important;
                display: flex;
                align-items: center;
                font-size: 0;
                text-align: center;
                background-color: #000000;
            }
        }
    .van-card{
        background: #fff;
        text-align: left;
        padding: 15px 10px;
        margin: 0 0 10px;
        span {
            transform: translateZ(0);
        }
        .van-card__origin-price{
            text-decoration: none;
        }
        .cardTitle{
            font-size:15px;
            font-family:PingFang SC;
            font-weight:bold;
            color:rgba(51,51,51,1);
            line-height:17px;
            white-space: nowrap;
            text-overflow:ellipsis;
            overflow:hidden;
            margin-bottom: 10px;
            height: 17px;
        }
        .cardDesc{
            font-size:12px;
            font-family:PingFang SC;
            font-weight:500;
            color:rgba(163,163,163,1);
            line-height:16px;
            white-space: nowrap;
            text-overflow:ellipsis;
            overflow:hidden;
        }
        .card-line {
            .card-line-item {
                border-right: 1px solid #B2B0B0;
                font-size: 12px;
                float: left;

                .sale-type {
                    color: #333333;
                    margin-right: 3px;
                }
                .sale-number {
                    color: #E85B4D;
                    margin-right: 7px;
                }
                .sale-time {
                    margin-left: 7px;
                }
            }
            .card-line-item:last-child {
                border: 0;
            }
        }
        .card-subLine {
            padding: 5px 0;
            font-size: 13px;
            color: #E85B4D;
        }
        .van-card__price{
            color: #E85B4D;
        }
        .cardNum{
            width:25px;
            height:25px;
            float: right;
        }
        .cardNumS{
            float: right;
            font-size: 16px;
            line-height: 25px;
            margin: 0 5px;
        }
      }
      .distributionP{
        font-size:15px;
        font-family:PingFang SC;
        font-weight:500;
        color:#666666;
        line-height:20px;
        padding: 15px;
        background: #fff;
        margin: 0 0 10px;
        span{
            display: inline-block;
            color:#333333;
            padding-right: 15px;
        }
      }
		.navBarBottom {
			width: 100%;
			background: #fff;
			overflow: hidden;
			padding: 10px 0;
            margin: 0 0 10px;
			.navBarBottomL {
				float: left;
				height: 100%;
				margin-left: 10px;
				img {
					display: block;
					width: 50px;
					height: 50px;
				}
			}
			.navBarBottomR {
				float: left;
				height: 100%;
				margin-left: 15px;
				.navBarBottomRP {
					font-size: 12px;
					font-family: PingFang SC;
					font-weight: 500;
					margin-top: 12px;
				}
				.navBarBottomRP_ {
					font-size: 15px;
					font-family: PingFang SC;
					font-weight: bold;
					line-height: 20px;
				}
			}
            .navBarBottomBtn{
                float: right;
                margin: 12px 10px 0 0;
            }
		}
      .van-goods-action{
          .van-button{
              border-radius:0;
              height: 100%;
              margin-right: -2px;
          }
      }
      .van-tabs{
          background: #fff;
          margin-bottom: 50px;
          .detail-editor p {
              font-size: 15px;
          }
          .evaluationBox{
              .evaluationTietle{
                  padding: 10px 0;
                    .evaluationTotalScore{
                        font-size:36px;
                        font-family:PingFang SC;
                        font-weight:bold;
                        color:#333;
                        line-height: 50px;
                        text-align: right;
                        padding-right: 5px;
                    }
                    .evaluationTotalScore_{
                        padding-left: 10px;
                        p{
                            font-size:12px;
                            font-family:PingFang SC;
                            font-weight:500;
                            color:#333;
                            line-height: 28px;
                        }
                        .van-icon{
                            font-size: 12px !important;
                        }
                    }
                    .evaluationTotalNum{
                        p{
                            font-size:12px;
                            font-family:PingFang SC;
                            font-weight:500;
                            color:#333;
                            line-height: 25px;
                        }
                        .evaluationTotalNum_{
                            font-size:18px;
                            font-family:PingFang SC;
                            font-weight:bold;
                            color:#666;
                            line-height: 18px !important;
                        }
                    }
              }
              .evaluationContent{
                  padding: 0 10px 15px;
                  overflow: hidden;
                  display: flex;
                  .evaluationContentImg{
                      float: left;
                      margin-right: 10px;
                      img{
                          width: 32px;
                          height: 32px;
                          border-radius: 32px;
                      }
                      flex: 1;
                  }
                  .evaluationContentInfo{
                      float: left;
                      flex: 15;
                      .evaluationContentInfoH{
                          p{
                                font-size:12px;
                                font-family:PingFang SC;
                                font-weight:500;
                                color:#333;
                                line-height: 18px;
                                span{
                                    color: #999;
                                    float: right;
                                }
                          }
                        .van-icon{
                            font-size: 10px !important;
                        }
                      }
                      .evaluationContentInfoBody{
                          .evaluationContentInfoBodyTitle{
                                font-size:15px;
                                font-family:PingFang SC;
                                font-weight:500;
                                color:#333;
                                line-height:18px;
                                margin: 5px 0;
                          }
                          .evaluationContentInfoBodyImg{
                              img{
                                  height: 94px;
                                  width: 100%;
                              }
                          }
                          .evaluationContentInfoBodyReply{
                                background:#F5F5F5;
                                border-radius:3px;
                                padding: 10px;
                                font-size:15px;
                                font-family:PingFang SC;
                                font-weight:500;
                                color:#696969;
                                line-height:18px;
                          }
                      }
                  }
              }
          }
      }
    }
</style>
